import * as React from 'react'

import { styled } from '@mui/material/styles'

import Slide from '@mui/material/Slide'
import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import Button from 'components/atomic/atoms/button'

const drawerWidth = 240

const Wrapper = styled('div')`
    width: 100%;
    position: fixed;
    background: ${({ theme }) => theme.palette.background.default};
    bottom: -1px;
    border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    right: 0px;
    z-index: 100;

    ${({ theme }) => theme.breakpoints.up('md')} {
        width: calc(100% - ${drawerWidth}px);
    }
`

interface IResourcesNav {
    handleConfirm?: () => void
    handleAbort?: () => void
    loading?: boolean
    show?: boolean
}

const ResourcesNav = (props: IResourcesNav) => {
    const { loading = false } = props

    const { t }: I18n = useTranslation()

    const next = () => {
        if (props.handleConfirm) props.handleConfirm()
    }

    const previous = () => {
        if (props.handleAbort) props.handleAbort()
    }

    return (
        <Wrapper style={{ height: !props.show ? 0 : undefined }}>
            <ResponsiveContainer>
                <Slide in={props.show} direction="up">
                    <Stack direction="row" spacing={2} justifyContent="flex-end" p={1}>
                        <Button disabled={loading} variant="outlined" onClick={() => previous()}>
                            {t('settings:buttons.abort')}
                        </Button>
                        <Button loading={loading} variant="contained" color="primary" onClick={() => next()}>
                            {t('settings:buttons.save')}
                        </Button>
                    </Stack>
                </Slide>
            </ResponsiveContainer>
        </Wrapper>
    )
}

export default ResourcesNav
